import React from 'react'
import { About, ContactUs, Hero, Services, Operation } from '../../components'

import './home.css'

const Home = () => {
  return (
    <>
      <div className='home-wrapper'>
        <Hero />
        <About />
        <Services />
        <Operation />
        <ContactUs />
      </div>
    </>
  )
}

export default Home